/* eslint-disable global-require */
import { LOCALIZATIONS } from 'lib/constants';

const audio = {
  hub_logout: {
    [LOCALIZATIONS.EN]: require('./en/hub_logout.mp3'),
    [LOCALIZATIONS.ES]: require('./en/hub_logout.mp3'),
    [LOCALIZATIONS.SPA_ES_DEFAULT]: require('./spa-es-default/hub_logout.mp3'),
  },
};

export default audio;
